import styled, { css } from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IStyledProps {
  $type?: 'list' | 'count' | string;
  $bgColor?: string;
  $pointColor?: string;
  $emphasisTextColor?: string;
}

const punch = css`
  position: absolute;
  content: '';
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #fff;
  z-index: 2;
`;

export const CouponItem3 = styled.div<IStyledProps>`
  position: relative;
  width: 100%;
  overflow: hidden;
  text-align: left;
  ${mixin.flex({ align: 'center', justify: 'flex-start' })}
  background: #000;

  ${({ $bgColor, $pointColor, $emphasisTextColor }) =>
    $bgColor &&
    css`
      background: ${$pointColor};

      .text-wrap {
        &:before,
        &:after {
          background: ${$bgColor} !important;
        }

        .title {
          color: ${$emphasisTextColor} !important;
        }

        .desc {
          color: ${$emphasisTextColor} !important;
        }
      }

      .area-cnt .text {
        color: ${$emphasisTextColor} !important;
      }
    `}

  &.bg-type-gray {
    background: #333;

    .text-wrap {
      &:before,
      &:after {
        background: #000;
      }
    }
  }

  .text-wrap {
    .title {
      font-size: 16px;
      line-height: 130%;
      font-weight: 600;
      ${mixin.ellipsis(1)};
      color: #fff;

      + .desc {
        margin-top: 4px;
      }
    }

    .desc {
      font-size: 12px;
      line-height: 130%;
      ${mixin.ellipsis(1)};
      color: #fff;
      opacity: 0.5;
    }
  }

  ${props => {
    switch (props.$type) {
      case 'list':
        return css`
          height: 70px;

          .text-wrap {
            width: 100%;
            padding: 0 40px 0 20px;

            &:after {
              ${punch};
              top: 50%;
              right: -5px;
              transform: translateY(-50%);
            }
          }
        `;
      case 'count':
        return css`
          height: 78px;
          border-radius: 4px;

          .text-wrap {
            width: calc(100% - 70px);
            padding: 19px 7px 18px 20px;

            &:before,
            &:after {
              ${punch};
              right: 65px;
            }

            &:before {
              top: -5px;
            }

            &:after {
              bottom: -5px;
            }
          }

          .area-cnt {
            position: relative;
            width: 70px;
            height: 100%;
            ${mixin.flex({})}

            .text {
              font-size: 14px;
              line-height: 130%;
              color: #fff;
              font-weight: 600;
              padding: 0 2px;
            }

            &:before {
              content: '';
              display: block;
              width: 1px;
              height: 38px;
              background: rgba(255, 255, 255, 0.2);
              position: absolute;
              top: 50%;
              left: 0px;
              transform: translateY(-50%);
            }
          }
        `;
      default:
        return null;
    }
  }}

  @media ${({ theme }) => theme.media.smMax} {
    .text-wrap {
      .title {
        font-size: ${mixin.pxToVw('16')};

        + .desc {
          margin-top: ${mixin.pxToVw('4')};
        }
      }

      .desc {
        font-size: ${mixin.pxToVw('12')};
      }
    }

    ${props => {
      switch (props.$type) {
        case 'list':
          return css`
            height: ${mixin.pxToVw('70')};

            .text-wrap {
              padding: ${mixin.pxToVw('0 40 0 20')};

              &:after {
                width: ${mixin.pxToVw('10')};
                height: ${mixin.pxToVw('10')};
                right: ${mixin.pxToVw('-5')};
              }
            }
          `;
        case 'count':
          return css`
            height: ${mixin.pxToVw('78')};
            border-radius: ${mixin.pxToVw('4')};

            .text-wrap {
              width: calc(100% - ${mixin.pxToVw('70')});
              padding: ${mixin.pxToVw('19 7 18 20')};

              &:before,
              &:after {
                right: ${mixin.pxToVw('65')};
                width: ${mixin.pxToVw('10')};
                height: ${mixin.pxToVw('10')};
              }

              &:before {
                top: ${mixin.pxToVw('-5')};
              }

              &:after {
                bottom: ${mixin.pxToVw('-5')};
              }
            }

            .area-cnt {
              width: ${mixin.pxToVw('70')};

              .text {
                font-size: ${mixin.pxToVw('14')};
                padding: ${mixin.pxToVw('0 2')};
              }

              &:before {
                height: ${mixin.pxToVw('38')};
              }
            }
          `;
        default:
          return null;
      }
    }}
  }

  @media ${({ theme }) => theme.media.pc} {
    width: 380px;

    .text-wrap {
      .desc {
        font-size: 13px;
      }
    }

    ${props => {
      switch (props.$type) {
        case 'list':
          return css`
            height: 68px;

            .text-wrap {
              padding: 0 40px 0 24px;

              &:after {
                width: 15px;
                height: 16px;
                right: -7.5px;
              }

              .title {
                font-size: 18px;

                + .desc {
                  margin-top: 4px;
                }
              }
            }
          `;
        case 'count':
          return css`
            height: 100px;

            .text-wrap {
              width: calc(100% - 77px);

              &:before,
              &:after {
                right: 72px;
              }

              .title {
                font-size: 20px;

                + .desc {
                  margin-top: 8px;
                }
              }
            }

            .area-cnt {
              width: 77px;

              .text {
                font-size: 16px;
              }

              &:before {
                height: 52px;
              }
            }
          `;
        default:
          return null;
      }
    }}
  }
`;
